import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import linkifyHtml from 'linkify-html';
import PropTypes from 'prop-types';

import { toggleFixedAlert } from '../../../../../redux/actions/general';
import { getNavbarConfigSelector } from '../../../../../redux/selectors/header';

const linkifyOpt = {
  attributes: {
    rel: 'noopener noreferrer nofollow',
  },
  target: {
    url: '_blank',
  },
  nl2br: true,
  formatHref: (href, type) => {
    if (type === 'url') {
      return `${window.location.origin}/anon.ws?r=${encodeURIComponent(href)}`;
    }
    return href;
  },
};

const Text = ({ message, additional }) => {
  const { fields, theme } = additional;

  const dispatch = useDispatch();
  const location = useLocation();
  const { access } = useSelector((state) => getNavbarConfigSelector(state));

  const onClickRoute = () => dispatch(toggleFixedAlert(true, location.pathname + location.search));

  if (!fields?.length) {
    return <div dangerouslySetInnerHTML={{ __html: linkifyHtml(message, linkifyOpt) }} />;
  }

  return (
    <>
      <div>
        <b>{theme}</b>
      </div>
      {fields?.map((field) => {
        const isOrdersIdsLink = field?.name?.toLowerCase()?.indexOf('order') !== -1 && field?.name?.toLowerCase()?.indexOf('id') !== -1 && /^[0-9,\s]*$/.test(field?.value);
        return (
          <div key={field.id}>
            <b>{field.name}</b>
            :
            {' '}
            {isOrdersIdsLink && access?.['orders-list'] ? (
              <Link to={`/orders?query=${field.value}&search_type=1`} onClick={onClickRoute} className="text-decoration-none">
                {field.value}
              </Link>
            ) : (
              <span>{field.value}</span>
            )}
          </div>
        );
      })}
      <hr />
      <div dangerouslySetInnerHTML={{ __html: linkifyHtml(message, linkifyOpt) }} />
    </>
  );
};

Text.propTypes = {
  message: PropTypes.string,
  additional: PropTypes.object,
};

export default Text;
